<template>
  <div class="statistics" style="width: 100%;overflow-x: scroll;">
    <div style="float:left;display: inline-block;margin-left:20px;">
      <div :class='["information_box","light_border"]'
           :style="[{width:'509px'},{'height':'839px'}]">
        <div class="border_top_left"></div>
        <div class="border_top_right"></div>
        <div class="border_bottom_left"></div>
        <div class="border_bottom_right"></div>
        <div><img src="../../../static/img/light_new.png" style=""></div>
      </div>
    </div>
    <div style="padding-left: 20px;float:left;display: inline-block;width:calc(100% - 560px)">
      <div :class='["information_box","light_border"]'
           :style="[{width:'45%'},{'height':'400px'}]" style="float:left;">
        <div class="border_top_left"></div>
        <div class="border_top_right"></div>
        <div class="border_bottom_left"></div>
        <div class="border_bottom_right"></div>
        <div class="h_light_right" :style="{top:'95px'}"></div>
        <div class="information_content">
          <div class="nva_btn">
            <button class="income_btn focus">设备数量统计</button>
          </div>
          <div id="LightRate"></div>
        </div>
      </div>

      <div :class='["information_box","light_border"]'
           :style="[{width:'45%'},{'margin-left':'20px'},{'height':'400px'}]" style="float:left;">
        <div class="border_top_left"></div>
        <div class="border_top_right"></div>
        <div class="border_bottom_left"></div>
        <div class="border_bottom_right"></div>
        <div class="h_light_right" :style="{top:'95px'}"></div>
        <div class="information_content">
          <div class="nva_btn">
            <button class="income_btn focus">告警分析</button>
          </div>
          <div id="FaultRate"></div>
        </div>
      </div>


      <div :class='["information_box","light_border"]'
           :style="[{width:'calc(90% + 20px)'},{'height':'400px'},{marginBottom:'20px'}]" style="padding-top: 20px;float:left;clear:both;">
        <div class="border_top_left"></div>
        <div class="border_top_right"></div>
        <div class="border_bottom_left"></div>
        <div class="border_bottom_right"></div>
        <div class="h_light_right" :style="{top:'95px'}"></div>
        <div class="information_content">
          <div class="nva_btn">
            <button @click="user_day()" class="income_btn focus">本日在线用户数</button>
            <button @click="user_month()" class="income_btn" style="display: none;">本月在线用户数</button>
            <button @click="user_quarter()" class="income_btn" style="display: none;">本季在线用户数</button>
          </div>
          <div id="user"></div>
        </div>
      </div>

      <!--<div :class='["information_box","light_border"]'
           :style="[{width:'calc(50% - 12px)'},{height:'calc(50% - 55px)'},{marginLeft:'20px'}]">
        <div class="border_top_left"></div>
      <div class="border_top_right"></div>
      <div class="border_bottom_left"></div>
      <div class="border_bottom_right"></div>
      <div class="h_light_right" :style="{top:'95px'}"></div>
      <!--<div="information_content">
       div class="nva_btn">
         <button class="income_btn focus">广告统计分析</button>
       </div>
        <div id="static"></div>
      </div>-->
      </div>


      <div :class='["information_box","light_border"]'
           :style="[{width:'100%'},{'min-height':'350px'},{height:'36.5%'}]" hidden>
        <div class="border_top_left"></div>
        <div class="border_top_right"></div>
        <div class="border_bottom_left"></div>
        <div class="border_bottom_right"></div>
        <div class="h_light_right" :style="{top:'95px'}"></div>
        <div class="information_content">
          <div class="nva_btn">
            <button @click="income_day()" class="income_btn focus">设备列表</button>
          </div>
          <div id="equipment">
            <table class="EmergencyTable">
              <thead>
              <tr>
                <th>灯杆编号</th>
                <th width="160px">地理位置</th>
                <th>时间段</th>
                <th>17:00</th>
                <th>18:00</th>
                <th>19:00</th>
                <th>20:00</th>
                <th>21:00</th>
                <th>22:00</th>
                <th>23:00</th>
                <th>00:00</th>
                <th>01:00</th>
                <th>02:00</th>
                <th>03:00</th>
                <th>04:00</th>
                <th>05:00</th>
                <th>06:00</th>
                <th>07:00</th>
                <th>08:00</th>
                <th>亮度</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(item,index) in tabledata">
                <td>{{item.lamppost_id}}</td>
                <td>{{item.site}}</td>
                <td>{{item.time_quantum}}</td>
                <td>
                  <div :style="0<=item.end_hour&&0>=item.start_hour?[{'background':color[index]}]:[]">
                    <span v-if="item.start_hour.toString()==='0'" style="display: block;width: 160px">{{item.start_time}}-{{item.end_time}}</span>
                  </div>
                </td>
                <td>
                  <div :style="1<=item.end_hour&&1>=item.start_hour?[{'background':color[index]}]:[]">
                    <span v-if="item.start_hour.toString()==='1'" style="display: block;width: 160px">{{item.start_time}}-{{item.end_time}}</span>
                  </div>
                </td>
                <td>
                  <div :style="2<=item.end_hour&&2>=item.start_hour?[{'background':color[index]}]:[]">
                    <span v-if="item.start_hour.toString()==='2'" style="display: block;width: 160px">{{item.start_time}}-{{item.end_time}}</span>
                  </div>
                </td>
                <td>
                  <div :style="3<=item.end_hour&&3>=item.start_hour?[{'background':color[index]}]:[]">
                    <span v-if="item.start_hour.toString()==='3'" style="display: block;width: 160px">{{item.start_time}}-{{item.end_time}}</span>
                  </div>
                </td>
                <td>
                  <div :style="4<=item.end_hour&&4>=item.start_hour?[{'background':color[index]}]:[]">
                    <span v-if="item.start_hour.toString()==='4'" style="display: block;width: 160px">{{item.start_time}}-{{item.end_time}}</span>
                  </div>
                </td>
                <td>
                  <div :style="5<=item.end_hour&&5>=item.start_hour?[{'background':color[index]}]:[]">
                    <span v-if="item.start_hour.toString()==='5'" style="display: block;width: 160px">{{item.start_time}}-{{item.end_time}}</span>
                  </div>
                </td>
                <td>
                  <div :style="6<=item.end_hour&&6>=item.start_hour?[{'background':color[index]}]:[]">
                    <span v-if="item.start_hour.toString()==='6'" style="display: block;width: 160px">{{item.start_time}}-{{item.end_time}}</span>
                  </div>
                </td>
                <td>
                  <div :style="7<=item.end_hour&&7>=item.start_hour?[{'background':color[index]}]:[]">
                    <span v-if="item.start_hour.toString()==='7'" style="display: block;width: 160px">{{item.start_time}}-{{item.end_time}}</span>
                  </div>
                </td>
                <td>
                  <div :style="8<=item.end_hour&&8>=item.start_hour?[{'background':color[index]}]:[]">
                    <span v-if="item.start_hour.toString()==='8'" style="display: block;width: 160px">{{item.start_time}}-{{item.end_time}}</span>
                  </div>
                </td>
                <td>
                  <div :style="9<=item.end_hour&&9>=item.start_hour?[{'background':color[index]}]:[]">
                    <span v-if="item.start_hour.toString()==='9'" style="display: block;width: 160px">{{item.start_time}}-{{item.end_time}}</span>
                  </div>
                </td>
                <td>
                  <div :style="10<=item.end_hour&&10>=item.start_hour?[{'background':color[index]}]:[]">
                    <span v-if="item.start_hour.toString()==='10'" style="display: block;width: 160px">{{item.start_time}}-{{item.end_time}}</span>
                  </div>
                </td>
                <td>
                  <div :style="11<=item.end_hour&&11>=item.start_hour?[{'background':color[index]}]:[]">
                    <span v-if="item.start_hour.toString()==='11'" style="display: block;width: 160px">{{item.start_time}}-{{item.end_time}}</span>
                  </div>
                </td>
                <td>
                  <div :style="12<=item.end_hour&&12>=item.start_hour?[{'background':color[index]}]:[]">
                    <span v-if="item.start_hour.toString()==='12'" style="display: block;width: 160px">{{item.start_time}}-{{item.end_time}}</span>
                  </div>
                </td>
                <td>
                  <div :style="13<=item.end_hour&&13>=item.start_hour?[{'background':color[index]}]:[]">
                    <span v-if="item.start_hour.toString()==='13'" style="display: block;width: 160px">{{item.start_time}}-{{item.end_time}}</span>
                  </div>
                </td>
                <td>
                  <div :style="14<=item.end_hour&&14>=item.start_hour?[{'background':color[index]}]:[]">
                    <span v-if="item.start_hour.toString()==='14'" style="display: block;width: 160px">{{item.start_time}}-{{item.end_time}}</span>
                  </div>
                </td>
                <td>
                  <div :style="15<=item.end_hour&&15>=item.start_hour?[{'background':color[index]}]:[]">
                    <span v-if="item.start_hour.toString()==='15'" style="display: block;width: 160px">{{item.start_time}}-{{item.end_time}}</span>
                  </div>
                </td>
                <td>{{item.brightness}}</td>
              </tr>
              <tr v-if="this.tabledataNull">
                <td>暂无数据</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>

      </div>

    </div>


  </div>
</template>

<script>
  //引入echarts
  let echarts = require('echarts/lib/echarts');
  // 引入柱状图组件
  require('echarts/lib/chart/bar');
  require('echarts/lib/chart/line');
  require('echarts/lib/chart/scatter');
  require('echarts/lib/chart/pie');
  require('echarts/lib/chart/effectScatter');
  // 引入提示框和title组件
  require('echarts/lib/component/tooltip');
  require('echarts/lib/component/title');
  require('echarts/lib/component/legend');
  require('echarts/lib/component/geo');


  export default {
    name: "statistics",
    data() {
      return {
        search: [
          {
            title: '选择项目',
            select: [
              {option: "科技厅高科技成果展"},
            ]
          },
        ],
        tabledata: [],
        color: [],
        tabledataNull:false,
        //缓存数组
        Light_Rate: [
          {value: 4,name: '照明灯具'},
          {value: 4,name: '摄像头'},
          {value: 4,name: '传感器'},
          {value: 4,name: 'WIFI-AP'},
          {value: 4,name: '一键报警'},
          {value: 4,name: '网络音柱'},
          {value: 4,name: 'LED屏'},
          {value: 0,name: '充电桩'},
        ],
        Failure_Rate: [
          {value: 0,name: '电流'},
          {value: 0,name: '电压'},
          {value: 0,name: '离线'},
          // {value: 0,name: '门磁'},
        ],
        ECA_Data:[
          // {date:'09-18',cumulative_power:"232"},
          // {date:'09-19',cumulative_power:"224"},
          // {date:'09-20',cumulative_power:"255"},
          // {date:'09-21',cumulative_power:"239"},
          // {date:'09-22',cumulative_power:"221"},
          // {date:'09-23',cumulative_power:"240"},
          // {date:'09-24',cumulative_power:"290"},
        ],
        user_data_day: [
          {name: "0时", value: 0},
          //{name: "1时", value: 315},
          {name: "2时", value: 0},
          //{name: "3时", value: 235},
          {name: "4时", value: 0},
          //{name: "5时", value: 131},
          {name: "6时", value: 1},
          //{name: "7时", value: 321},
          {name: "8时", value: 2},
          //{name: "9时", value: 315},
          {name: "10时", value: 9},
          //{name: "11时", value: 316},
          {name: "12时", value: 18},
          //{name: "13时", value: 325},
          {name: "14时", value: 6},
          //{name: "15时", value: 395},
          {name: "16时", value: 8},
          //{name: "17时", value: 312},
          {name: "18时", value: 12},
          //{name: "19时", value: 321},
          {name: "20时", value: 4},
          //{name: "21时", value: 191},
          {name: "22时", value: 1},
          //{name: "23时", value: 321},
        ],
        user_data_mouth: [
          {name: "1", value: 215},
          //{name: "2", value: 315},
          {name: "3", value: 925},
          //{name: "4", value: 1235},
          {name: "5", value: 211},
          //{name: "6", value: 131},
          {name: "7", value: 236},
          //{name: "8", value: 321},
          {name: "9", value: 325},
          //{name: "10", value: 315},
          {name: "11", value: 395},
          //{name: "12", value: 316},
          {name: "13", value: 312},
          //{name: "14", value: 325},
          {name: "15", value: 321},
          //{name: "16", value: 325},
          {name: "17", value: 315},
          //{name: "18", value: 395},
          {name: "19", value: 316},
          //{name: "20", value: 312},
          {name: "21", value: 325},
          //{name: "22", value: 321},
          {name: "23", value: 312},
          //{name: "24", value: 325},
          {name: "25", value: 321},
          //{name: "26", value: 312},
          {name: "27", value: 325},
          //{name: "28", value: 321},
          {name: "29", value: 312},
          //{name: "30", value: 325},
        ],
        user_data_quarter: [
          {name: "6月", value: 65498},
          {name: "7月", value: 52356},
          {name: "8月", value: 46132},
        ],

      }
    },
    mounted() {
      //初始化表格
      this.user_day();
      this.Light_rate();
      this.Fault_Rate();
      let color = ["#4e95fe", "#86d7f8", "#609cfe", "#8676ff", "#99ffcd", "#febc64", "#d6e057"];
      let colorAarry = []
      for (let i = 0; i < 10000; i++) {
        let ColorRandom = color[Math.floor(Math.random() * color.length)];
        colorAarry.push(ColorRandom);
      }
      this.color = colorAarry;
      fetch('/api/v1/lamp/task/list', {
        method: 'post',
      })
        .then(result => {
          console.log(result)
          return result.json();//解析流
        })
        .then(data => {
          this.tabledata = data.data;
        })
        .catch((error) => {
          this.tabledataNull = true;
          throw  error
        });
    },
    created() {
      this.innt();
      this.getEnergyList();
      this.InitLeftMenu();
    },
    methods: {
      InitLeftMenu: function () {
        this.$emit('getMessage', '0', '0');
      },
      Light_rate: function () {
        // if(this.income_data_quarter!==""){
        //   // this.$axios.get("",{
        //   //
        //   // }).then((res)=>{
        //   //    this.income_data_quarter = res
        //   // })
        // }
        var Light_Rate = this.Light_Rate;
        let myChart1 = echarts.init(document.getElementById('LightRate'));
        myChart1.setOption({
          tooltip: {
            trigger: 'item',
            formatter: "{b} : {c} ({d}%)"
          },
          series: [{
            name: '亮灯率',
            type: 'pie',
            radius: '70%',
            center: ['50%', '50%'],
            color: [ '#5EA6FE', '#45FBF7', '#48FF58', '#EAE809', '#FF7E3F', '#FF4746', '#E177F9', '#4E6BFF'], //'#FBFE27','rgb(11,228,96)','#FE5050'
            data: Light_Rate.sort(function(a, b) {
              return a.value - b.value
            }),
            roseType: 'radius',

            label: {
              normal: {
                formatter: ['{c|{c}}', '{b|{b}}'].join('\n'),
                rich: {
                  c: {
                    color: '#ffffff',
                    fontSize: 20,
                    fontWeight:'bold',
                    lineHeight: 5
                  },
                  b: {
                    color: 'rgb(98,137,169)',
                    fontSize: 15,
                    height: 40
                  },
                },
              }
            },
            labelLine: {
              normal: {
                lineStyle: {
                  color: 'rgb(98,137,169)',
                },
                smooth: 0.2,
                length: 10,
                length2: 20,

              }
            },
            itemStyle: {
              normal: {
                shadowColor: 'rgba(0, 0, 0, 0.8)',
                shadowBlur: 50,
              }
            }
          }]
        });
        window.onresize = function () {
          myChart1.resize();
        };
      },

      Fault_Rate: function () {
        // if(this.income_data_quarter!==""){
        //   // this.$axios.get("",{
        //   //
        //   // }).then((res)=>{
        //   //    this.income_data_quarter = res
        //   // })
        // }
        var Fault_Rate = this.Failure_Rate;
        let ccc = echarts.init(document.getElementById('FaultRate'));
        ccc.setOption({
          tooltip: {
            trigger: 'item',
            formatter: "{b} : {c} ({d}%)"
          },
          series: [{
            name: '故障率',
            type: 'pie',
            radius: '70%',
            center: ['50%', '50%'],
            color: ['#FE5050', '#1DB7E5','#FBFE27'], //'#FBFE27','rgb(11,228,96)','#FE5050'
            data: Fault_Rate.sort(function(a, b) {
              return a.value - b.value
            }),
            roseType: 'radius',

            label: {
              normal: {
                formatter: ['{c|{d}%}', '{b|{b}}'].join('\n'),
                rich: {
                  c: {
                    color: '#ffffff',
                    fontSize: 20,
                    fontWeight:'bold',
                    lineHeight: 5
                  },
                  b: {
                    color: 'rgb(98,137,169)',
                    fontSize: 15,
                    height: 40
                  },
                },
              }
            },
            labelLine: {
              normal: {
                lineStyle: {
                  color: 'rgb(98,137,169)',
                },
                smooth: 0.2,
                length: 10,
                length2: 20,

              }
            },
            itemStyle: {
              normal: {
                shadowColor: 'rgba(0, 0, 0, 0.8)',
                shadowBlur: 50,
              }
            }
          }]
        });
        window.onresize = function () {
          ccc.resize();
        };
      },

      user_day: function () {
        // if(this.income_data_quarter!==""){
        //   // this.$axios.get("",{
        //   //
        //   // }).then((res)=>{
        //   //    this.income_data_quarter = res
        //   // })
        // }
        let date = [];
        let data = [];
        for (let i = 0; i < this.user_data_day.length; i++) {
          date.push(this.user_data_day[i].name);
          data.push(this.user_data_day[i].value);
        }
        let myChart1 = echarts.init(document.getElementById('user'));
        myChart1.setOption({
          tooltip: {
            trigger: 'axis',
            axisPointer: {            // 坐标轴指示器，坐标轴触发有效
              type: 'shadow',        // 默认为直线，可选为：'line' | 'shadow'
              shadowStyle: {
                color: {
                  type: 'linear',
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [{
                    offset: 0, color: 'rgba(1,200,179,0)' // 0% 处的颜色
                  }, {
                    offset: 1, color: 'rgba(1,200,179,1)' // 100% 处的颜色
                  }],
                  global: false // 缺省为 false
                },
                opacity: 0.35
              }
            },
          },
          grid: {
            left: "5%",
            right: "5%",
            top: "12%",
            bottom: "10%",
            containLabel: true
          },
          xAxis: [{
            type: "category",
            data: date,
            axisTick: {
              alignWithLabel: true
            },
            nameTextStyle: {
              color: "#ffffff"
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "#244465",

              }
            },
            offset: 5,
            axisLabel: {
              textStyle: {
                color: "#ffffff"
              }
            }
          }],
          yAxis: [{
            name: "人次",
            type: "value",
            nameTextStyle: {
              color: "#ffffff",
              fontSize: 14,
              align: "left",
            },
            axisLabel: {
              show: false,
              textStyle: {
                color: "#ffffff"
              },
            },
            splitLine: {
              show: false,
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "#244465",
              }
            }
          }],
          series: [{
            type: "line",
            smooth: true,
            symbolSize: 12,
            symbol: 'circle',
            itemStyle: {
              normal: {
                opacity: 1,
                color: "#01c8b3",
                shadowColor: 'rgba(0,156,140,0.35)',
                shadowBlur: 5,
                shadowOffsetY: 5
              },
            },
            lineStyle: {
              width: 4,
              color: '#01c8b3',
              shadowColor: 'rgba(72,216,191, 0.3)',
              shadowBlur: 5,
              shadowOffsetY: 5
            },
            markPoint: {
              symbol: 'circle',
              symbolSize: 20,
              data: [
                {type: 'max', name: '最大值'},
                {type: 'min', name: '最小值'}
              ],
              label: {
                show: true,
                position: "top",
                color: '#ffffff'
              }
            },
            markLine: {
              symbol: 'none',
              label: {
                position: "left",
                formatter: '{c}',
                color:"#ffffff",
              },
              data: [
                {
                  name: "最大值",
                  type: 'max',//res.targetTwo,
                  lineStyle: {
                    color: "#244465"
                  },
                }, {
                  name: "最小值",
                  type: 'min',//res.targetTwo,
                  lineStyle: {
                    color: "#244465"
                  },
                }
              ]
            },
            data: data
          }]
        });
        window.onresize = function () {
          myChart1.resize();
        };
      },

      user_month: function () {
        // if(this.income_data_quarter!==""){
        //   // this.$axios.get("",{
        //   //
        //   // }).then((res)=>{
        //   //    this.income_data_quarter = res
        //   // })
        // }
        let date = [];
        let data = [];
        for (let i = 0; i < this.user_data_mouth.length; i++) {
          date.push(this.user_data_mouth[i].name);
          data.push(this.user_data_mouth[i].value);
        }
        let myChart1 = echarts.init(document.getElementById('user'));
        myChart1.setOption({
          tooltip: {
            trigger: 'axis',
            axisPointer: {            // 坐标轴指示器，坐标轴触发有效
              type: 'shadow',        // 默认为直线，可选为：'line' | 'shadow'
              shadowStyle: {
                color: {
                  type: 'linear',
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [{
                    offset: 0, color: 'rgba(1,200,179,0)' // 0% 处的颜色
                  }, {
                    offset: 1, color: 'rgba(1,200,179,1)' // 100% 处的颜色
                  }],
                  global: false // 缺省为 false
                },
                opacity: 0.35
              }
            },
          },
          grid: {
            left: "5%",
            right: "5%",
            top: "12%",
            bottom: "10%",
            containLabel: true
          },
          xAxis: [{
            type: "category",
            data: date,
            axisTick: {
              alignWithLabel: true
            },
            nameTextStyle: {
              color: "#ffffff"
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "#244465",

              }
            },
            offset: 5,
            axisLabel: {
              textStyle: {
                color: "#ffffff"
              }
            }
          }],
          yAxis: [{
            name: "人次",
            type: "value",
            nameTextStyle: {
              color: "#ffffff",
              fontSize: 14,
              align: "left",
            },
            axisLabel: {
              show: false,
              textStyle: {
                color: "#ffffff"
              },
            },
            splitLine: {
              show: false,
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "#244465",
              }
            }
          }],
          series: [{
            type: "line",
            smooth: true,
            symbolSize: 12,
            symbol: 'circle',
            itemStyle: {
              normal: {
                opacity: 1,
                color: "#01c8b3",
                shadowColor: 'rgba(0,156,140,0.35)',
                shadowBlur: 5,
                shadowOffsetY: 5
              },
            },
            lineStyle: {
              width: 4,
              color: '#01c8b3',
              shadowColor: 'rgba(72,216,191, 0.3)',
              shadowBlur: 5,
              shadowOffsetY: 5
            },
            markPoint: {
              symbol: 'circle',
              symbolSize: 20,
              data: [
                {type: 'max', name: '最大值'},
                {type: 'min', name: '最小值'}
              ],
              label: {
                show: true,
                position: "top",
                color: '#ffffff'
              }
            },
            markLine: {
              symbol: 'none',
              label: {
                position: "left",
                formatter: '{c}',
                color:"#ffffff",
              },
              data: [
                {
                  name: "最大值",
                  type: 'max',//res.targetTwo,
                  lineStyle: {
                    color: "#244465"
                  },
                }, {
                  name: "最小值",
                  type: 'min',//res.targetTwo,
                  lineStyle: {
                    color: "#244465"
                  },
                }
              ]
            },
            data: data
          }]
        });
        window.onresize = function () {
          myChart1.resize();
        };
      },

      user_quarter: function () {
        // if(this.income_data_quarter!==""){
        //   // this.$axios.get("",{
        //   //
        //   // }).then((res)=>{
        //   //    this.income_data_quarter = res
        //   // })
        // }
        let date = [];
        let data = [];
        for (let i = 0; i < this.user_data_quarter.length; i++) {
          date.push(this.user_data_quarter[i].name);
          data.push(this.user_data_quarter[i].value);
        }
        let myChart1 = echarts.init(document.getElementById('user'));
        myChart1.setOption({
          tooltip: {
            trigger: 'axis',
            axisPointer: {            // 坐标轴指示器，坐标轴触发有效
              type: 'shadow',        // 默认为直线，可选为：'line' | 'shadow'
              shadowStyle: {
                color: {
                  type: 'linear',
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [{
                    offset: 0, color: 'rgba(1,200,179,0)' // 0% 处的颜色
                  }, {
                    offset: 1, color: 'rgba(1,200,179,1)' // 100% 处的颜色
                  }],
                  global: false // 缺省为 false
                },
                opacity: 0.35
              }
            },
          },
          grid: {
            left: "5%",
            right: "5%",
            top: "12%",
            bottom: "10%",
            containLabel: true
          },
          xAxis: [{
            type: "category",
            data: date,
            axisTick: {
              alignWithLabel: true
            },
            nameTextStyle: {
              color: "#ffffff"
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "#244465",

              }
            },
            offset: 5,
            axisLabel: {
              textStyle: {
                color: "#ffffff"
              }
            }
          }],
          yAxis: [{
            name: "人次",
            type: "value",
            nameTextStyle: {
              color: "#ffffff",
              fontSize: 14,
              align: "left",
            },
            axisLabel: {
              show: false,
              textStyle: {
                color: "#ffffff"
              },
            },
            splitLine: {
              show: false,
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "#244465",
              }
            }
          }],
          series: [{
            type: "line",
            smooth: true,
            symbolSize: 12,
            symbol: 'circle',
            itemStyle: {
              normal: {
                opacity: 1,
                color: "#01c8b3",
                shadowColor: 'rgba(0,156,140,0.35)',
                shadowBlur: 5,
                shadowOffsetY: 5
              },
            },
            lineStyle: {
              width: 4,
              color: '#01c8b3',
              shadowColor: 'rgba(72,216,191, 0.3)',
              shadowBlur: 5,
              shadowOffsetY: 5
            },
            markPoint: {
              symbol: 'circle',
              symbolSize: 20,
              data: [
                {type: 'max', name: '最大值'},
                {type: 'min', name: '最小值'}
              ],
              label: {
                show: true,
                position: "top",
                color: '#ffffff'
              }
            },
            markLine: {
              symbol: 'none',
              label: {
                position: "left",
                formatter: '{c}',
                color:"#ffffff",
              },
              data: [
                {
                  name: "最大值",
                  type: 'max',//res.targetTwo,
                  lineStyle: {
                    color: "#244465"
                  },
                }, {
                  name: "最小值",
                  type: 'min',//res.targetTwo,
                  lineStyle: {
                    color: "#244465"
                  },
                }
              ]
            },
            data: data
          }]
        });
        window.onresize = function () {
          myChart1.resize();
        };
      },

      // innt : function(){
      //   var imgDatUrl = 'image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAADECAYAAAD3RIMaAAADg0lEQVR4nO3dP28cRQCG8Wf29nKORRQXoUqQI6TYyCcRQAHJ6fgECAk3INFQBuUDIAoaKmihpKUwRYQoKNMlBZKrWKIACZNgExMSI58v9u3MUNw6cWzj9/7YCsX7SKNbnXdnf/LO7pUbQvUTJCADCULqf5KAuOfz8DFHZKEeULFIZDFElqkg1PuFCFSBUG+H+HS788Hr7K1k+OaAhXq09/2tDXwG3AEW67E8zOSDgo5CHFZ7VNxRoHYNeG9AxDC47+rtA4V9a6gdEgv0x9wAa+jZUbFnzcg1tBwiiyGGxc0PX7uzF9QmsUDuI4Zc1OOAnm6n8HOxE39lp/dy+eafEz/8cqa3/rAVX8pjXJexynmGlGcByrPbxcU3tlsXU4DV09Xd3yZ7VTfkaSCctCP0EsXjSNiJT871ZFEXGc5vlRfOb5V0G5mVid76WhknKvKZY0XEnBubMRRbkRAPXpND77LTMTDbOfXiDPCgjPxeVhsPiS9kaIykyORGJ4Xyn0jRTUf+5498DgXgXNXgXNU4ux0ya6HiLtX2Y3JrEEfYyZQPEuVGCqEabIUO/KRu5cB0bjJNs/UoJO6FivtUKUHxzI6JXP6dQnk/0ugMf5uM8tPBFAVTjVPMNprFWhX5Y6eisxFpribK9RhCHGXWfoXe5b8rCVwoS96anGByqUdzLTIOZmzQSWSQyiCVQSqDVAapDFIZpDJIZZDKIJVBKoNUBqkMUhmkMkhlkMoglUEqg1QGqQxSGaQySGWQyiCVQSqDVAapDFIZpDJIZZDKIJVBKoNUBqkMUhmkMkhlkMoglUEqg1QGqQxSGaQySGWQyiCVQSqDVAapDFIZpDJIZZDKIJVBKoNUBqkMUhmkMkhlkMoglUEqg1QGqQxSGaQySGWQyiCVQSqDVAapDFIZpDJIZZDKIJVBKoNUBqn+l6CrwO3nDaFvmC+AW/RR7wMrzwGyUp/76sb1+du77+vIwLfADeBj4BNg6oQhj4DPga82rs93d7/cv4a6wBfAJeBr+m8COu6qeu5LwJd7MYeBdvsLuAZcBr4/RsyNes5r9TkOpO6yZeAd4G1gaQzIUj3Hu4gXYg16298ErgAfAfeGgKzUx1yp55AN8xxKwDf0r/2nwOYR+27W+7xSH5MGPckoD8Yu/btj5pCTVfV3M/U+3QNHnwBot1X6l+NV4Md6XK6/Wx110n8BkRQ3ib0+PwAAAAAASUVORK5CYII=';
      //   var dimensions = ['5s', '10s', '15s', '30s', '45s', '60s'];
      //   var static_data = [42, 36, 13, 56, 9, 28];
      //
      //   let myChart2 = echarts.init(document.getElementById('static'));
      //   myChart2.setOption({
      //     tooltip: {
      //       trigger: 'axis',
      //     },
      //     grid: {
      //       left: '5%',
      //       top: "12%",
      //       right: '5%',
      //       bottom: '10%',
      //       containLabel: true
      //     },
      //     xAxis: {
      //       data: dimensions,
      //       axisTick: {
      //         alignWithLabel: true
      //       },
      //       nameTextStyle: {
      //         color: "#ffffff"
      //       },
      //       axisLine: {
      //         show: true,
      //         lineStyle: {
      //           color: "#244465",
      //
      //         }
      //       },
      //       offset: 5,
      //       axisLabel: {
      //         textStyle: {
      //           color: "#ffffff"
      //         }
      //       }
      //     },
      //     yAxis: {
      //       name: "收入(万元)",
      //       type: "value",
      //       nameTextStyle: {
      //         color: "#ffffff",
      //         fontSize: 14,
      //         align: "left",
      //       },
      //       axisLabel: {
      //         show: true,
      //         textStyle: {
      //           color: "#ffffff"
      //         },
      //       },
      //       splitLine: {
      //         show: true,
      //         lineStyle: {
      //           type: 'dashed',
      //           color: '#244465 '
      //         }
      //       },
      //       axisLine: {
      //         show: true,
      //         lineStyle: {
      //           color: "#244465",
      //         }
      //       }
      //     },
      //     series: [{
      //       name: '收入',
      //       type: 'pictorialBar',
      //       symbol: imgDatUrl,
      //       color: "#45ded6",
      //       barGap: 0,
      //       symbolSize: [36, '100%'],
      //       data: static_data
      //     }]
      //   });
      //   window.onresize = function () {
      //     myChart2.resize();
      //   };
      // },

      getEnergyList:function(){
        //获取灯的能耗
        fetch("/api/v1/statistics/lamp/energyConsumption", {
          method: 'post',
          body: JSON.stringify({

          })
        })
          .then(result => {
            return result.json();//解析流
          })
          //.then(data => console.log(data))
          .then(data => {
            if (data.code == "200") {
              this.message = "能耗数据更新成功";
              this.refresh = true;
              this.msg_show = !this.msg_show;
              this.ECA_Data = data.data;
              this.ECA();
              //this.Switch = data.data.lamp.status;
            } else {
              this.message = "数据更新异常，请重试";
              this.msg_show = !this.msg_show;
            }
          })
          .catch((error) => {
            this.message = "网络异常，请重试";
            this.msg_show = !this.msg_show;
          });
      },

      ECA:function () {
        let date = [];
        let data = [];
        for (let i = 0; i < this.ECA_Data.length; i++) {
          date.push(this.ECA_Data[i].date);
          data.push(this.ECA_Data[i].cumulative_power);
        };
        let myChart3 = echarts.init(document.getElementById('ECA'));
        myChart3.setOption({
          grid: {
            top: '20%',
            right: '60px',
            left: '60px',
            bottom: '15%'
          },
          xAxis: [{
            type: 'category',
            data:date,
            axisLine: {
              lineStyle: {
                color: 'rgba(255,255,255,0.12)'
              }
            },
            axisLabel: {
              margin: 10,
              color: '#e2e9ff',
              textStyle: {
                fontSize: 14
              },
            },
          }],
          yAxis: [{
            name:"单位（kw）",
            type: "value",
            nameTextStyle: {
              color: "#ffffff",
              fontSize: 14,
              align: "left",
            },
            axisLabel: {
              formatter: '{value}',
              color: '#e2e9ff',
            },
            axisLine: {
              show: false
            },
            splitLine: {
              lineStyle: {
                color: 'rgba(255,255,255,0.12)'
              }
            }
          }],
          series: [{
            type: 'bar',
            data: data,
            barWidth: '20px',
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                  offset: 0,
                  color: 'rgba(0,244,255,1)' // 0% 处的颜色
                }, {
                  offset: 1,
                  color: 'rgba(0,77,167,1)' // 100% 处的颜色
                }], false),
                barBorderRadius: [30, 30, 30, 30],
                shadowColor: 'rgba(0,160,221,1)',
                shadowBlur: 4,
              }
            },
            label: {
              normal: {
                show: true,
                lineHeight: 30,
                width: 80,
                height: 30,
                backgroundColor: 'rgba(0,160,221,0.1)',
                borderRadius: 200,
                position: ['-8', '-60'],
                distance: 1,
                formatter: [
                  '    {d|●}',
                  ' {a|{c}kw}     \n',
                  '    {b|}'
                ].join(','),
                rich: {
                  d: {
                    color: '#3CDDCF',
                  },
                  a: {
                    color: '#fff',
                    align: 'center',
                  },
                  b: {
                    width: 1,
                    height: 30,
                    borderWidth: 1,
                    borderColor: '#234e6c',
                    align: 'left'
                  },
                }
              }
            }
          }]
        });
        window.onresize = function () {
          myChart3.resize();
        };
      }
    },

  }
</script>

<style scoped>
  .statistics {
    width: 100%;
    height: 100%;
  }

  .search {
    width: 100%;
    height: 76px;
    padding: 0;
  }

  .search_options_box {
    width: 275px;
    padding: 0 10px;
    height: 100%;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }

  .search_options_box > span {
    width: 64px;
    margin-right: 8px;
    text-align: right;
    color: #FFFFFF;
  }

  .search_options_box > select {
    width: calc(100% - 72px);
    height: 36px;
    border-radius: 6px;
    background: transparent;
    border: 1px solid #5a7595;
    color: #ffffff;
    appearance: none;
    padding-left: 10px;
    font-size: 16px;
    outline: none;
    cursor: pointer;
  }

  .search_options_box option {
    color: #000000;
  }

  .search_options_box > img {
    position: absolute;
    top: 36px;
    right: 20px;
    cursor: pointer;
  }

  .statistical_overview {
    width: 100%;
    height: 120px;
    display: flex;
    justify-content: space-between;
  }

  .statistical_box {
    width: calc(20% - 16px);
    height: 100%;
    background-color: #0b2f54;
    border-radius: 6px;
    border: 1px solid #5a7192;
    -webkit-box-shadow: 0 0 10px #16518d inset;
    box-shadow: 0 0 10px #16518d inset;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .statistical_box > div:nth-child(1) {
    width: 80px;
    height: 80px;
    margin: 0 20px;
  }

  .statistical_box > div:nth-child(2) {
    font-size: 20px;
    font-weight: bold;
  }

  .nva_btn {
    padding: 20px;
  }
  .information_content>div:nth-child(2){
    width: 100%;
    height: calc(100% - 67px);
  }
  .income_btn {
    background: transparent;
    font-size: 16px;
    border: transparent;
    outline: transparent;
    color: #95bee5;
    margin-right: 20px;
  }

  .focus {
    font-size: 18px;
    color: #00f0ff;
  }

  #equipment {
    padding: 0 20px;
    box-sizing: border-box;
    height: calc(100% - 87px);
  }

  #equipment table {
    width: 100%;
    height: 100%;
    border: 1px solid #094b8e;
  }

  #equipment table thead tr {
    height: 40px;
    border-bottom: 1px solid #094b8e;
  }

  #equipment table thead tr th {
    color: #FFFFFF;
    font-size: 16px;
  }

  #equipment table tbody {
    display: block;
    height: 100%;
    overflow-y: scroll;
  }

  #equipment table thead tr,
  #equipment table tbody tr {
    display: table;
    width: 100%;
    table-layout: fixed;
    text-align: center;
  }

  #equipment table tbody tr {
    background: #16518d;
  }

  #equipment table tbody tr:nth-child(2n+0) {
    background: #11406f;
  }

  #equipment table tbody tr td {
    height: 40px;
    width: auto;
    color: #FFFFFF;
    border-bottom: 3px solid transparent;
    border-top: 3px solid transparent;
  }
  #equipment table tbody tr td div{
    width: 100%;
    height: 30px;
    line-height: 30px;
  }
  #equipment table thead {
    width: calc(100% - 1em);
  }


</style>



// WEBPACK FOOTER //
// src/components/05Management/1_operation.vue